<template>
    <!-- dealer select template -->
    <div class="dealer" role="group" aria-label="dealer">
        <div class="row name-and-button">
            <div :class="partnumber != undefined && partnumber.stock.IsRetailDirectToConsumer == false ? 'col-md-5' : 'col-md-12'">
                <h4 class="dealername">{{dealer.Name}}</h4>
            </div>
            <div class="col-md-7 order-button" v-if="partnumber != undefined && partnumber.stock.IsRetailDirectToConsumer == false">
                <button class="btn btn-select" v-if="product.SellLocalStock" v-on:click="$emit('selectDealerAndAddToCart', dealer)">
                    <span>{{getInterfaceText('shop_order_from_this_store')}}</span>
                </button>
                <!--<button class="btn btn-select" v-if="sellLocalStock == false" v-on:click="toggleDetails(dealer);">
                    <span>{{getInterfaceText('shop_contactdealer')}}</span>
                </button>-->
            </div>
        </div>
        <div class="row text-address-etc">
            <div class="col-md-12">
                <div class="in-store-now-text" v-if="dealer.DealerStock != null && dealer.DealerStock.Type == 3 && dealer.DealerStock.DateExpectedToFormat != null">
                    {{getInterfaceText('limbo_available_from')}}
                    <span class="available-in-text clearfix">{{getInterfaceText('limbo_available_from_sub')}}</span>
                    <!--{{getInterfaceText('limbo_available_from')}} {{dealer.DealerStock.DateExpectedToFormat}}-->
                </div>
                <div class="in-store-now-text" v-else-if="dealer.DealerStock != null && dealer.DealerStock.Type == 2 && dealer.DealerStock.DateExpectedToFormat != null">
                    {{getInterfaceText('buffer_available_from')}}
                    <span class="available-in-text clearfix">{{getInterfaceText('buffer_available_from_sub')}}</span>
                    <!--{{getInterfaceText('buffer_available_from')}} {{dealer.DealerStock.DateExpectedToFormat}}-->
                </div>
                <div v-else>
                    <div class="in-store-now-text" v-if="isInStoreNowTextVisible && partnumber != undefined && partnumber.stock.IsRetailDirectToConsumer == false">
                        {{getInterfaceText('shop_instorenow')}}
                    </div>
                    <div class="available-in-text" v-if="isAvailableInTextVisible && partnumber != undefined && partnumber.stock.IsRetailDirectToConsumer == false && product.SellLocalStock">
                        <span class="available-for">{{getInterfaceText('shop_inwarehouse_availableforpickup')}}&nbsp;</span>
                        <span v-if="dealer.DealerStock != null && dealer.DealerStock.Type == 3 && dealer.DealerStock.DateExpectedToFormat != null">
                            {{dealer.DealerStock.DateExpectedToFormat}}
                        </span>
                        <span v-else-if="dealer.Type == 'local'">
                            {{getInterfaceText('shop_istorenow_nrofdays')}}
                        </span>
                        <span v-else>
                            {{getInterfaceText('shop_inwarehouse_nrofdays')}}
                        </span>
                    </div>
                </div>
                <div class="distance">
                    {{dealer.DistanceToFormat}} {{measurement}} | {{ dealer.City }} {{ dealer.State }} {{ dealer.Country != null && dealer.Country.length > 0 ? '| ' + dealer.Country : '' }}
                </div>
                <a href="javascript:void(0)" v-on:click="toggleDetails(dealer);" class="show-details">
                    <span class="showdetails" v-if="!dealer.showDetails">{{getInterfaceText('shop_showdetails')}}</span>
                    <span class="hidedetails" v-if="dealer.showDetails">{{getInterfaceText('shop_hidedetails')}}</span>
                </a>
            </div>

        </div>
        <div class="row row-details" v-if="dealer.showDetails">
            <div class="col-md-12">
                <p class="dealer-details">
                    {{dealer.Street}}<br />
                    {{dealer.Zipcode}} {{dealer.City}} <br />
                    <span v-if="dealer.Phone">{{getInterfaceText('phone')}}: {{dealer.Phone}} <br /></span>
                    {{ dealer.Email }} <br />
                    <span v-show="dealer.WebAddress"><a :href="'//' + dealer.WebAddress" target="_blank" class="track-GA4-event" data-ga4_name="show_retailer_detail" :data-ga4_model_category="product.GA_Category" :data-ga4_model_name="product.Name" :data-ga4_retailer_name="dealer.Name" :data-ga4_click_text="dealer.WebAddress">{{dealer.WebAddress}} </a></span>
                </p>
                <div class="googlemap-container">
                    <div :id="'map-canvas-page-'+ dealer.Code + '-' + dealer.Type" ref="map-dealer-{{dealer.Code}}" class="map-canvas"></div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import generalMixin from '../mixins/general.js';
    export default {
        name: 'DealerSelect',
        props: ['dealer', 'selectedDealer', 'isInStoreNowTextVisible', 'isAvailableInTextVisible', 'partnumber', 'product'],
        mixins: [generalMixin],
        data: function () {
            return {
                measurement: window.measurement
            }
        },
        methods: {
            toggleDetails(dealer) {
                dealer.showDetails = !dealer.showDetails;

                if (dealer.showDetails) {
                    // show map
                    this.showGoogleMaps(dealer, 'page');
                    // SK add ga4 tracking
                    var clickText = this.getInterfaceText('shop_showdetails');
                    window.trackEventGlobalAndLocalGA4({ 'ga4_name': 'show_retailer_detail', 'ga4_model_category': this.product.GA_Category, 'ga4_model_name': this.product.Product.Name, 'ga4_retailer_name': dealer.Name, 'ga4_click_text': clickText });
                }

            },
            showGoogleMaps(dealer, viewMode) {
                setTimeout(function () {
                    var myLatLng = new window.google.maps.LatLng(dealer.Latitude, dealer.Longitude);
                    var bounds = new window.google.maps.LatLngBounds();
                    var mapOptions = {
                        center: myLatLng,
                        zoom: 10,
                        mapTypeControl: false,
                        mapTypeId: window.google.maps.MapTypeId.ROADMAP
                    }

                    var mapCanvas = document.getElementById('map-canvas-' + viewMode + '-' + dealer.Code + '-' + dealer.Type);

                    var map = new window.google.maps.Map(mapCanvas, mapOptions);
                    var marker = new window.google.maps.Marker({
                        position: myLatLng,
                        map: map
                    });

                    bounds.extend(marker.getPosition());
                    window.google.maps.event.trigger(map, "resize");
                });
            }
        },
        created() {
            this.interfaceTexts = JSON.parse(document.getElementById('vue-parameters').dataset.interfacetexts);
        }
    }
</script>
